import React from 'react'
import Navbar from '../Home/Navbar';
import Footer from '../Home/Footer';
import { CartProvider } from 'react-use-cart';
import Laptop from './Laptop';

function AllLaptop() {
  return (
    <CartProvider>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <Laptop/>
        <Footer/>
    </CartProvider>
  )
}

export default AllLaptop;